export interface IOffice {
  addons?: IOfficeAddon[];
  address: string;
  description: string;
  email: string;
  facebook_url: string;
  id: number;
  instagram_url: string;
  map_location_url: string;
  name: string;
  phone: string;
  site_url: string;
  telegram_url: string;
  whatsapp_url: string;
  working_hours: IOfficeWorkingHours[];
  x_url: string;
}

export interface IOfficeAddon {
  addon_id: EOfficeAddon;
  addon_info: unknown[];
  is_enabled: boolean;
  office_id: number;
}

export enum EOfficeAddon {
  BonusBalance = 'bonus_balance',
  Booking = 'booking',
}

export interface IOfficeWorkingHours {
  end_day: number;
  end_time: string;
  start_day: number;
  start_time: string;
}
